import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0edb2e2c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edb2e2c')) {
      api.createRecord('0edb2e2c', component.options)
    } else {
      api.reload('0edb2e2c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0edb2e2c&", function () {
      api.rerender('0edb2e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PdljHn5WMR91/JS/offershelp.vue"
export default component.exports